import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.219.438c-5.53 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13l-3.59 3.59-3.59-3.59-1.41 1.41 3.59 3.59-3.59 3.59 1.41 1.41 3.59-3.59 3.59 3.59 1.41-1.41-3.59-3.59 3.59-3.59-1.41-1.41z" fill="#07A" /></svg>;